import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202405/summer-vacation-homework-2024-teacher/index.vue')

export const indexRoute: RouteConfig = {
  path: '/summer-vacation-2024-homework',
  name: 'summer_vacation_2024_homework',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2024暑假体育作业方案',
    ignoreLogin: true,
  },
}

export default [indexRoute]
